(function () {
  var article = document.querySelector('.hello-main-article');
  if (!article) return;

  var content = article.querySelector('.hello-main-article__content');
  if (!content) return;

  var headerEeat = article.querySelector('.hello-main-article__eeat');
  var bodyEeat = content.querySelector('.hello-article-eeat');
  var meta = article.querySelector('.hello-main-article__meta');
  if (headerEeat && bodyEeat) {
    bodyEeat.hidden = true;
  } else if (bodyEeat && meta && meta.parentNode) {
    meta.after(bodyEeat);
  }

  var about = Array.prototype.find.call(content.querySelectorAll('h2'), function (h2) {
    return /^about hello mrs$/i.test((h2.textContent || '').trim());
  });
  if (about && !about.closest('.hello-article-about')) {
    var wrap = document.createElement('div');
    wrap.className = 'hello-article-about';
    about.parentNode.insertBefore(wrap, about);
    wrap.appendChild(about);
    var node = wrap.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      var next = node.nextElementSibling;
      wrap.appendChild(node);
      node = next;
    }
  }

})();
